import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';

import { FilterPageModule } from './pages/admin/filter/filter.module';
import { MapPageModule } from './pages/admin/map/map.module';
import { TestsPageModule } from './pages/admin/tests/tests.module';
import { MedicalmapPageModule } from './pages/admin/medicalmap/medicalmap.module';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { APP_CONFIG, BaseAppConfig } from './app.config';

import { YoutubeVideoPlayer } from '@ionic-native/youtube-video-player/ngx';

import { SignCompInToolbarComponent } from './pages/subscriber/sign-comp-in-toolbar/sign-comp-in-toolbar.component';
import {EmergencyRequestCenterModule} from './pages/subscriber/emergency-request-center/emergency-request-center.module';
import {ChooseDoctorModule} from './pages/subscriber/choose-doctor/choose-doctor.module';
import {ChooseDoctorListModalModule} from './pages/subscriber/choose-doctor-list-modal/choose-doctor-list-modal.module';
import {DoctorProfileDetailModalModule} from './pages/subscriber/doctor-profile-detail-modal/doctor-profile-detail-modal.module';
import {NotificationPanelModule} from './pages/subscriber/notification-panel/notification-panel.module';
import {NotificationDetailModule} from './pages/subscriber/notification-detail/notification-detail.module';
import {PharmacyMapModule} from './pages/subscriber/pharmacy-map/pharmacy-map.module';

import {AngularFirestore} from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import {AuthService} from './pages/admin/auth/auth.service';
import { FirebaseAuthentication } from '@ionic-native/firebase-authentication/ngx';
import { AngularFireStorageModule } from '@angular/fire/storage';
import { AdminRoutingModule } from './pages/admin/admin-routing.module';
import { SubscriberRoutingModule } from './pages/subscriber/subscriber-routing.module';
import { ExpertRoutingModule } from './pages/expert/expert-routing.module';


import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
import { CustomSearchModule } from './pages/custom-search-bar.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { BackgroundMode } from '@ionic-native/background-mode/ngx';
import { SocialSharing } from '@ionic-native/social-sharing/ngx';
import { LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { NgCalendarModule  } from 'ionic2-calendar';
import { CalendarModule  } from 'ion2-calendar';
import {IonicStorageModule} from '@ionic/storage';
import localeTr from '@angular/common/locales/tr';
import { registerLocaleData } from '@angular/common';
registerLocaleData(localeTr);

const config = {
  apiKey: 'AIzaSyAZAyM_sDQQnFPAYlXH7R0d70DMFqHIf8Y',
  authDomain: 'drproject-345a5.firebaseapp.com',
  databaseURL: 'https://drproject-345a5.firebaseio.com',
  projectId: 'drproject-345a5',
  storageBucket: 'drproject-345a5.appspot.com',
  messagingSenderId: '874342864603',
  appId: '1:874342864603:web:ccd5f909045a6e83b05efe',
  measurementId: 'G-RHJKNPR128'
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent, SignCompInToolbarComponent],
  entryComponents: [],
    imports: [
      // tslint:disable-next-line:indent
    BrowserModule,
    BrowserAnimationsModule,
      // tslint:disable-next-line:indent
	  IonicModule.forRoot(),
      AngularFireModule.initializeApp(config),
      AngularFirestoreModule,
      AngularFireAuthModule,
      AngularFireStorageModule,
      AppRoutingModule,
      AdminRoutingModule,
      ExpertRoutingModule,
      SubscriberRoutingModule,
      HttpClientModule,
      FilterPageModule,
      MapPageModule,
      TestsPageModule,
      TranslateModule,
      CustomSearchModule,
      MedicalmapPageModule,
        PharmacyMapModule,
        EmergencyRequestCenterModule,
        ChooseDoctorModule,
        ChooseDoctorListModalModule,
        DoctorProfileDetailModalModule,
        NotificationPanelModule,
        NotificationDetailModule,
        NgCalendarModule,
        CalendarModule,
        IonicStorageModule.forRoot(),
      TranslateModule.forRoot({
        loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
      ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production })
  ],
  providers: [
    BackgroundMode,
    StatusBar,
    SplashScreen,
    { provide: APP_CONFIG, useValue: BaseAppConfig },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    YoutubeVideoPlayer,
      AngularFirestore,
      AuthService,
      FirebaseAuthentication,
      AndroidPermissions,
      SocialSharing,
      LocalNotifications,
      Clipboard,
      { provide: LOCALE_ID, useValue: 'tr-TR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
